module.exports = __webpack_public_path__ + "media/images/Logo-d88fb7aa1e6b8d5a7b2101e5c2c1af5b.png";